module.exports = __webpack_public_path__ + "img/xidixiaochengxu.8e5b6fd2.png";